(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/mybets-common-wager/assets/javascripts/models/wager.js') >= 0) return;  svs.modules.push('/components/numbergames/mybets-common-wager/assets/javascripts/models/wager.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
svs.numbergames.mybets_common_wager.models.Wager = svs.numbergames.core.NumbergamesModel.extend({
  defaults: {
    wagerId: undefined,
    productName: '',
    productId: '',
    betAmount: undefined,
    channel: '',
    bagType: 0,
    packageName: undefined,
    description: '',
    extraDescription: undefined,
    descriptionItems: undefined,
    isSystemWager: false,
    isPackageWager: false,
    isCompositePackage: false,
    isSingleWager: false,
    isUserBoards: false,
    isSubscription: false,
    isFraction: false,
    fractionHolderFractionCount: 0,
    fractionHolderAmount: undefined,
    customerFractionCount: 0,
    isSyndicate: false,
    syndicateId: undefined,
    syndicateName: undefined,
    syndicateBettor: undefined,
    syndicateParticipantCount: undefined,
    syndicateParticipatingMembers: undefined,
    syndicateMembers: undefined,
    syndicateCurrentMember: undefined,
    syndicateIsPermissionBlocked: false,
    isCancellable: true,
    currentDrawNumber: '',
    currentAddonDrawNumber: undefined,
    currentDrawCount: 1,
    isCancelClosed: false,
    isPreProlonged: false,
    cancelCloseTime: '',
    isRegClosed: false,
    regCloseTime: '',
    isProlonged: false,
    firstDrawNumber: undefined,
    completedDrawCount: 0,
    totalDrawCount: 1,
    hasMultipleDraws: false,
    regWagerTime: '',
    lastDrawDate: '',
    isExamined: false,
    winAmount: 0,
    completedOn: '',
    bet: undefined,
    jokerBet: undefined,
    rowCount: 0,
    hasLotto2: false,
    hasJoker: false,
    lotto1Bet: undefined,
    lotto2Bet: undefined,
    originalNumDraws: undefined,
    originalApiWager: undefined
  },
  url() {
    return "".concat(svs.core.jupiter.url(), "/player/1/wagers/").concat(this.get('wagerId'));
  },
  parseRawResponse(resp) {
    return resp.wager;
  },
  initialize() {
    svs.numbergames.mybets_common_wager.logger.debug('models.Wager initialize', this.attributes);
  },
  parse(attrs, options) {
    svs.numbergames.mybets_common_wager.logger.debug('models.Wager parse', attrs);
    const originalApiWager = attrs;
    if (options !== null && options !== void 0 && options.parseFinishedWager) {
      [attrs] = svs.numbergames.mybets_core_wager.parsers.parseFinishedWagers([attrs], options.context.syndicates);
    } else {
      attrs = svs.numbergames.mybets_core_wager.parsers.parseWager(attrs);
    }
    if (attrs.bet) {
      attrs.bet = new svs.numbergames.mybets_common_wager.models.Bet(attrs.bet, {
        parse: true
      });
    }
    if (attrs.jokerBet) {
      attrs.jokerBet = new svs.numbergames.mybets_common_wager.models.Bet(attrs.jokerBet, {
        parse: true
      });
    }
    return _objectSpread(_objectSpread({}, attrs), {}, {
      originalApiWager
    });
  }
});

 })(window);